<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/guanhuai',title:'用户交互'},{title:'季度抢单-客户'}]"/>-->
      <Breadtabsheader/>
        <div class="h-content">
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                        <div class="h-thirdColumn w-newColumn">
                            <el-form-item label="区域经理">
                                <el-input v-model="q.areaManager" placeholder="请输入区域经理工号或姓名"></el-input>
                            </el-form-item>
                            <el-form-item label="年度">
                                <el-select filterable v-model="q.year" clearable placeholder="请选择"
                                >
                                    <el-option
                                            v-for="(item) in qyearList"
                                            :key="item"
                                            :label="item"
                                            :value="item">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="季度" prop="quarterly">
                                <el-select v-model="q.quarterly" :clearable="true"
                                           placeholder="请选择">
                                    <el-option label="1" value="1"></el-option>
                                    <el-option label="2" value="2"></el-option>
                                    <el-option label="3" value="3"></el-option>
                                    <el-option label="4" value="4"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="区域" prop="area">
                                <brselect clearable category="show_area" :v="q.area"
                                          v-model="q.area"></brselect>
                            </el-form-item>
                        </div>
                        <div class="h-thirdColumn w-newColumn">
                            <el-form-item label="链群" prop="lianqun">
                                <brselect category="xsyb_lianqun" :v="q.lianqun" :showcode="true"
                                          v-model="q.lianqun" clearable></brselect>
                            </el-form-item>
                            <el-form-item label="渠道" prop="scenes">
                                <brselect category="sales_region" :v="q.scenes" :showcode="true"
                                          v-model="q.scenes" clearable></brselect>
                            </el-form-item>
                        </div>
                    </el-form>
                    <div class="l-screenBox">
                        <div class="l-retrieval">
                            <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                            <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置
                            </el-button>
                            <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" @click="createNew">
                                新建目标
                            </el-button>
                        </div>
                    </div>
                </div>
            </div>
          <div class="h-table h-mrt30 tableclslist">
            <!--                <div class="h-rowIn" style="width: 100%;">-->
            <!--                    <div style="height: 7.3rem;overflow: hidden;position: relative;">-->
            <!--                        <div class="h-rowBox" style="border-bottom: none;box-shadow: none;">-->
            <el-table
                ref="multipleTable"
                @selection-change="handleSelectionChange"
                :data="tableData"
                :border="true"
                stripe
                max-height="450"
                style="width: 100%">
              <el-table-column
                  type="selection"
                  min-width="4%">
              </el-table-column>
              <el-table-column
                  type="index"
                  label="#" min-width="4%">
              </el-table-column>
              <el-table-column
                  prop="areaName"
                  label="区域"
                  min-width="7%"
              >
              </el-table-column>
              <el-table-column
                  prop="areaManagerName"
                  label="区域经理"
                  :show-overflow-tooltip="true"
                  min-width="7%"
              >
              </el-table-column>
              <el-table-column
                  prop="scenesName"
                  label="渠道"
                  min-width="7%"
              >
              </el-table-column>
              <el-table-column
                  prop="lianqunName"
                  label="链群"
                  min-width="7%"
              >
              </el-table-column>
              <el-table-column
                  prop="customerName"
                  label="经销商名称"
                  :show-overflow-tooltip="true"
                  min-width="20%"
              >
              </el-table-column>
              <el-table-column
                  prop="year"
                  label="年"
                  min-width="7%"
              >
              </el-table-column>
              <el-table-column
                  prop="quarterly"
                  label="季度"
                  min-width="7%"
              >
              </el-table-column>
              <!-- 遍历T+3到T+13周周列信息,分多级表头,第一级表头是周信息,第二级表头为周包含日信息 -->
              <el-table-column
                  v-for="(column,index) in monthList"
                  :key = "column.value"
                  :prop="column.value"
                  :label="column.key"
                  min-width="8%">
              </el-table-column>
              <el-table-column
                  prop="cdate"
                  label="创建时间"
                  min-width="10%"
                  :formatter="formatDate"
              >
              </el-table-column>
              <el-table-column
                  fixed="right"
                  label="操作"
                  min-width="10%"
              >
                <template slot-scope="scope">
                  <el-button type="text"
                             size="small"
                             class="h-tableLink h-btn"
                             @click="updateDetail(scope.row)"
                  >编辑</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
            <div class="h-tableB h-mrt30">
                <div class="h-tableBL">
                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export"
                               @click="uploaddownexcelflagbtn">批量导入
                    </el-button>
                    <uploaddownexcel
                            :visible.sync="uploaddownexcelflag"
                            v-if="uploaddownexcelflag"
                            clsname="quarterlyGrabCustomerExcel"
                            :startrow="2" @callback="uploadExcelFilecallback"/>
                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                               @click="exportRqExcel()">批量导出
                    </el-button>
                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export"
                               @click="deleteBatch()">批量删除
                    </el-button>
                </div>
                <div class="h-pagination2">
                    <pagination :page="q" @query="query" style="padding-top: 0.1rem"/>
                </div>
            </div>

        </div>
        <!-- 弹出层 -->
        <el-dialog :close-on-click-modal="false" @close='closeDialog' :visible.sync="newDialog" class="h-dialog2">
            <div class="h-dialogImg">
                <div class="h-disTable">
                    <div class="h-tableCell">
                        <h1>新建目标</h1>
                    </div>
                </div>
            </div>
            <div class="h-formLines">
                <div style="padding: 12px;" class="dialogout X-dai">
                    <el-form :model="add" label-position="right" :inline="true" :rules="editFormRules" label-width="120"
                        class="demo-ruleForm h-formbLine h-formbLine1">
<!--                        <el-form-item label="区域经理" prop="areaManager">-->
<!--                            <el-select v-model="add.areaManager"  remote filterable :filter-method="showFormList" clearable  placeholder="请输入"-->
<!--                                    :remote-method="showFormList" @change="showFormList" >-->
<!--                                        <el-option v-for="(item,index) in optionList"-->
<!--                                                    :key="index"-->
<!--                                                    :label="item.username"-->
<!--                                                    :value="item.usercode">-->
<!--                                        </el-option>-->
<!--                                    </el-select>-->
<!--                        </el-form-item>-->
                        <el-form-item label="渠道"  prop='scenes'>
                          <brselect category="sales_region" v-model="add.scenes" :v="add.scenes" :clearable="true" />
                        </el-form-item>
                        <el-form-item   label="链群">
                            <brselect category="xsyb_lianqun" :v="add.lianqun" v-model="add.lianqun" :clearable="true"/>
                        </el-form-item>
                        <!-- <el-form-item label="渠道">
                            <el-input v-model="add.scenesName" placeholder="自带出" disabled=""></el-input>
                        </el-form-item> -->

                        <el-form-item label="经销商名称" prop="customerName">
                            <el-select v-model="add.customerName" remote filterable :filter-method="showComList" clearable :disabled="isDsi"  placeholder="请输入"
                                    :remote-method="showComList" @change="showComList" >
                                <el-option v-for="(item) in customerNameList"
                                        :key="item.userName"
                                        :label="item.userName"
                                        :value="item.userName">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="年度">
                            <el-select filterable v-model="add.year" clearable :disabled="this.updateFlag" placeholder="请选择">
                                <el-option
                                        v-for="(item) in qyearList"
                                        :key="item"
                                        :label="item"
                                        :value="item">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="季度" prop="quarterly">
                                <el-select v-model="add.quarterly" :clearable="true"
                                    @change="changeQuarter"      placeholder="请选择" :disabled="this.updateFlag">
                                    <el-option label="1" value="1"></el-option>
                                    <el-option label="2" value="2"></el-option>
                                    <el-option label="3" value="3"></el-option>
                                    <el-option label="4" value="4"></el-option>
                                </el-select>
                            </el-form-item>

                        <!--<div class="addPro">
                             <el-form-item>
                                <el-input v-model="add.grabOrderMap.month"></el-input>
                            </el-form-item>
                            <el-form-item :label="`${(this.title )}月抢单`"  prop="money1 ">
                                <el-input v-model="add.grabOrderMap[0].money1 "  onkeyup="value=value.replace(/[^\d]/g,'')"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-input v-model="add.grabOrderMap.month"></el-input>
                            </el-form-item>
                            <el-form-item :label="`${(this.title + 1)}月抢单`"  prop="money2">
                                <el-input v-model="add.grabOrderMap[1].money2" onkeyup="value=value.replace(/[^\d]/g,'')"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-input v-model="add.grabOrderMap.month"></el-input>
                            </el-form-item>
                            <el-form-item :label="`${(this.title + 2)}月抢单`"  prop="money3">
                                <el-input v-model="add.grabOrderMap[2].money3" onkeyup="value=value.replace(/[^\d]/g,'')"></el-input>
                            </el-form-item>
                        </div> -->
                        <div class="addPro" >
                            <el-form-item v-for="(listIt, index) in add.grabOrders" :key="index"  :label="`${(add.grabOrders[index].month )}月抢单`"  prop="grabOrder">
                                <el-input v-model="add.grabOrders[index].grabOrder"   ></el-input>
                            </el-form-item>
                        </div>
                        <!-- <el-form-item :label="`参数${(index + 1)}类型`" v-for="(item, index,) in props.row">
                            <span v-text="item"></span>
                        </el-form-item> -->
                    </el-form>
                </div>
                <div style="display:flex;justify-content:center;margin-bottom:20px">
                    <el-button class="h-btn h-bBtn h-bgwhite" @click="exit">取消</el-button>
                    <el-button class="h-btn h-bBtn h-bgblueQ2" @click="commitCreate()">提交</el-button>
                </div>
            </div>
        </el-dialog>

      <el-dialog :close-on-click-modal="false" @close='closeDialog' :visible.sync="updateDialog" class="h-dialog2">
        <div class="h-dialogImg">
          <div class="h-disTable">
            <div class="h-tableCell">
              <h1>编辑目标</h1>
            </div>
          </div>
        </div>
        <div class="h-formLines">
          <div style="padding: 12px;" class="dialogout X-dai">
            <el-form :model="update" label-position="right" :inline="true" :rules="editFormRules" label-width="120"
                     class="demo-ruleForm h-formbLine h-formbnpm Line1">
<!--              <el-form-item label="区域经理" prop="areaManager">-->
<!--                <el-select v-model="update.areaManager"  remote filterable :filter-method="showFormList" clearable  placeholder="请输入"-->
<!--                           :remote-method="showFormList" @change="showFormList" >-->
<!--                  <el-option v-for="(item,index) in optionList"-->
<!--                             :key="index"-->
<!--                             :label="item.username"-->
<!--                             :value="item.usercode">-->
<!--                  </el-option>-->
<!--                </el-select>-->
<!--              </el-form-item>-->
              <el-form-item label="渠道"  prop='scenes'>
                <brselect category="sales_region" v-model="update.scenes" :v="update.scenes" :clearable="true" />
              </el-form-item>
              <el-form-item   label="链群">
                <brselect category="xsyb_lianqun" :v="update.lianqun" v-model="update.lianqun" :clearable="true"/>
              </el-form-item>
              <!-- <el-form-item label="渠道">
                  <el-input v-model="add.scenesName" placeholder="自带出" disabled=""></el-input>
              </el-form-item> -->
              <el-form-item label="经销商名称" prop="customerName">
                <el-select v-model="update.customerName" remote filterable :filter-method="showComList" clearable  placeholder="请输入"
                           :remote-method="showComList" @change="showComList" >
                  <el-option v-for="(item) in customerNameList"
                             :key="item.userName"
                             :label="item.userName"
                             :value="item.userName">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="年度">
                <el-select filterable v-model="update.year" clearable disabled placeholder="请选择">
                  <el-option
                      v-for="(item) in qyearList"
                      :key="item"
                      :label="item"
                      :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="季度" prop="quarterly">
                <el-select v-model="update.quarterly" :clearable="true"
                           @change="changeQuarter"      placeholder="请选择" disabled>
                  <el-option label="1" value="1"></el-option>
                  <el-option label="2" value="2"></el-option>
                  <el-option label="3" value="3"></el-option>
                  <el-option label="4" value="4"></el-option>
                </el-select>
              </el-form-item>

              <!--<div class="addPro">
                   <el-form-item>
                      <el-input v-model="add.grabOrderMap.month"></el-input>
                  </el-form-item>
                  <el-form-item :label="`${(this.title )}月抢单`"  prop="money1 ">
                      <el-input v-model="add.grabOrderMap[0].money1 "  onkeyup="value=value.replace(/[^\d]/g,'')"></el-input>
                  </el-form-item>
                  <el-form-item>
                      <el-input v-model="add.grabOrderMap.month"></el-input>
                  </el-form-item>
                  <el-form-item :label="`${(this.title + 1)}月抢单`"  prop="money2">
                      <el-input v-model="add.grabOrderMap[1].money2" onkeyup="value=value.replace(/[^\d]/g,'')"></el-input>
                  </el-form-item>
                  <el-form-item>
                      <el-input v-model="add.grabOrderMap.month"></el-input>
                  </el-form-item>
                  <el-form-item :label="`${(this.title + 2)}月抢单`"  prop="money3">
                      <el-input v-model="add.grabOrderMap[2].money3" onkeyup="value=value.replace(/[^\d]/g,'')"></el-input>
                  </el-form-item>
              </div> -->
              <div class="addPro" >
                <el-form-item v-for="(listIt, index) in update.grabOrders" :key="index"  :label="`${(update.grabOrders[index].month )}月抢单`"  prop="grabOrder">
                  <el-input v-model="update.grabOrders[index].grabOrder"   ></el-input>
                </el-form-item>
              </div>
              <!-- <el-form-item :label="`参数${(index + 1)}类型`" v-for="(item, index,) in props.row">
                  <span v-text="item"></span>
              </el-form-item> -->
            </el-form>
          </div>
          <div style="display:flex;justify-content:center;margin-bottom:20px">
            <el-button class="h-btn h-bBtn h-bgwhite" @click="closeDialog">取消</el-button>
            <el-button  class="h-btn h-bBtn h-bgblueQ2" @click="commitUpdate()">修改</el-button>
          </div>
        </div>
      </el-dialog>
    </div>
</template>

<script>
    import ss from '../../../api/SystemService'
    import updownfile from '../../../utils/updownfile'
    import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'

    export default {
        components: {
            uploaddownexcel,
        },
        data() {
            return {
                q: {
                    areaManager:'',
                    area: '',
                    scenes: '',
                    lianqun:'',
                    //customerName: '',
                    year: '2021',
                    quarterly: '',
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                monthTime: new Date(),
                tablelist: [],
                tableName: {},
                tableData: [],
                quyuList: [],
                qyearList: [],
                monthList: {},
                //表格
                multipleSelection: [],
                multipleSelectionDialog:[],
                uploaddownexcelflag:false,
                updateFlag: false,
                updateDialog:false,
                mDate:'',
                qdetail: {
                    id: null,
                    demandType: null,
                    customer: {
                        areaCode: null,
                    }
                },
                dayInfoList: [],
                tableLoadStatus: false,
                newDialog:false,
                isDsi:false,
                optionList:[],
                customerNameList:[],
                add:{
                    areaManager:'',
                    lianqun:'',
                    scenes:'',
                    customerName:'',
                    year:'',
                    quarterly:'',
                    grabOrders:[
                        {month:'',grabOrder:''},
                    ],
                },
                update:{
                  areaManager:'',
                  lianqun:'',
                  scenes:'',
                  year:'',
                  quarterly:'',
                  grabOrders:[
                    {month:'',grabOrder:''},
                  ],
                },
                title:1,
                editFormRules: {
                username: [{required: true, message: '请输入必填项', trigger: 'blur'}],
                chanel: [{required: true, message: '请输入必填项', trigger: 'blur'}],
                product:[{required: true, message: '请输入必填项', trigger: 'blur'}],
                month:[{required: true, message: '请输入必填项', trigger: 'blur'}],
                grabBill:[{required: true, message: '请输入必填项', trigger: 'blur'}],
            },
            }
        },
        beforeRouteLeave(to, from, next) {
            from.meta.keepAlive = false;
            next();
        },
        activated(){
            this.query();
        },
        methods: {
            commitCreate(){
                //this.$set(this.add, "grabOrderMap", month);
                console.log(this.add)
                var data = this.add
                ss.grabOrderCust.saveGrabOrder(data).then(res => {
                    console.log(res)
                    if (res.f) {
                        this.$message({
                            type: "success",
                            message: res.msg
                        });
                        this.query();
                        this.closeDialog()
                    } else {
                        this.$message({
                            type: "error",
                            message: response.msg
                        });
                    }
                })
            },
            commitUpdate(){
                var data =this.update
                ss.grabOrderCust.editGrabOrder(data).then(res => {
                    console.log(res)
                    if (res.f) {
                        this.$message({
                            type: "success",
                            message: res.msg
                        });
                        this.query();
                        this.updateDialog = false;
                    } else {
                        this.$message({
                            type: "error",
                            message: response.msg
                        });
                    }
                })
            },
            showComList(value) {
                ss.netApi.selectUserName(value).then(res => {
                    console.log(res)
                    this.customerNameList = res.msg
                    this.add.usercode = res.msg[0].userCode
                    this.add.area = res.msg[0].area
                })
            },
            showFormList(value) {
                ss.grabOrderCust.selectUserName(value).then(res => {
                    console.log(res.msg)
                    this.optionList = res.msg
                    // this.add.usercode = res.msg[0].userCode
                    // this.add.area = res.msg[0].area
                })
            },
            //changeQuarter  改变季度
            changeQuarter(value){
                console.log(value)
                if(value == 1){
                    this.title = 1
                    this.add.grabOrders=[
                        {month:1,grabOrder:''},
                        {month:2,grabOrder:''},
                        {month:3,grabOrder:''}
                    ]
                }else if(value == 2){
                    this.title = 4
                    this.add.grabOrders=[
                        {month:4,grabOrder:''},
                        {month:5,grabOrder:''},
                        {month:6,grabOrder:''}
                    ]
                }else if(value == 3){
                    this.title = 7
                    this.add.grabOrders=[
                        {month:7,grabOrder:''},
                        {month:8,grabOrder:''},
                        {month:9,grabOrder:''}
                    ]
                }else if(value == 4){
                    this.title = 10
                    this.add.grabOrders=[
                        {month:10,grabOrder:''},
                        {month:11,grabOrder:''},
                        {month:12,grabOrder:''}
                    ]
                }
            },
            //编辑
            updateDetail(row){
                var data = row.id
                ss.grabOrderCust.selectById(data).then(res => {
                    console.log(res.msg)
                    //this.add = res.data.msg
                    var data = res.msg
                    this.update.id = data.id;
                    this.update.areaManager = data.areaManagerName
                    this.update.areaManagerCode = data.areaManager
                    this.update.lianqun = data.lianqun,
                    this.update.scenes= data.scenes,
                    this.update.customerName= data.customerName,
                    this.update.year= data.year,
                    this.update.quarterly= data.quarterly,
                    this.update.grabOrders= data.grabOrders
                    if(data.quarterly == 3){
                        this.title = 7
                        this.update.grabOrders= data.grabOrders
                        // this.add.grabOrders=[
                        //     {month:7,grabOrder:''},
                        //     {month:8,grabOrder:''},
                        //     {month:9,grabOrder:''}
                        // ]
                    }else if(data.quarterly == 1){
                        this.title = 1
                        this.update.grabOrders= data.grabOrders
                        // this.add.grabOrders=[
                        //     {month:1,grabOrder:''},
                        //     {month:2,grabOrder:''},
                        //     {month:3,grabOrder:''}
                        // ]
                    }else if(value == 2){
                        this.title = 4
                        this.update.grabOrders= data.grabOrders
                        // this.add.grabOrders=[
                        //     {month:4,grabOrder:''},
                        //     {month:5,grabOrder:''},
                        //     {month:6,grabOrder:''}
                        // ]
                    }else if(value == 4){
                        this.title = 10
                        this.update.grabOrders= data.grabOrders
                        // this.add.grabOrders=[
                        //     {month:10,grabOrder:''},
                        //     {month:11,grabOrder:''},
                        //     {month:12,grabOrder:''}
                        // ]
                    }
                });
               // this.add=row
                //var month = row.year + "-" + row.month
                this.$set(this.update, "id", row.id);
                this.update.grabOrders = row.grabOrders
                this.updateDialog = true;
            },
            createNew(){
                this.newDialog = true;
                this.updateFlag = false;
                this.getCustomerCode();
            },
            getCustomerCode(){
              if(localStorage.getItem("userId") != null){
                var userId = localStorage.getItem("userId")
                console.log("userId",userId)
                ss.netApi.selectUserId(userId).then(res => {
                  if(res.f == true && res.msg.length >= 1){
                    this.isDsi = true;
                    this.add.customerName = res.msg[0].userName
                    this.add.usercode = res.msg[0].userCode
                    this.add.area = res.msg[0].area
                  }
                })
              }
            },

            //重置检索项
            resetData() {
                this.q.areaManager = '',
                this.q.customerCode = '',
                this.q.area = '',
                this.q.lianqun = '',
                this.q.scenes = ''
            },
            //检索
            handleFilter(query) {
                this.query();
                this.getMonthList();
            },
            //表格
            query() {
                ss.grabOrderCust.selectPage(this.q).then(rd => {
                    this.q.total = rd.total;
                    this.tableData = rd.records;
                    this.tableLoadStatus = true;
                });
            },
            dateFormatter(str){//默认返回yyyy-MM-dd HH-mm-ss
                var hasTime = arguments[1] != false ? true : false;//可传第二个参数false，返回yyyy-MM-dd
                var d = new Date(str);
                var year = d.getFullYear();
                var month = (d.getMonth()+1)<10 ? '0'+(d.getMonth()+1) : (d.getMonth()+1);
                var day = d.getDate()<10 ? '0'+d.getDate() : d.getDate();
                var hour = d.getHours()<10 ? '0'+d.getHours() : d.getHours();
                var minute = d.getMinutes()<10 ? '0'+d.getMinutes() : d.getMinutes();
                var second = d.getSeconds()<10 ? '0'+d.getSeconds() : d.getSeconds();
                console.log("日期",[year, month].join('-'))
                return [year, month].join('-');
            },
            exportRqExcel(item){
                ss.grabOrderCust.downloadBatchExcel(this.q).then(res => { // 处理返回的文件流
                    const link = document.createElement('a')
                    let blob = new Blob([res],{type: 'application/vnd.ms-excel'});
                    link.style.display = 'none'
                    link.href = URL.createObjectURL(blob);
                    link.setAttribute('download', `季度抢单-客户导出详情.xlsx`)
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)
                }).catch(function (error) {
                    console.log("导出错误",error.toString())
                });
            },
            getQuyu(){
                ss.RiqPingj.selectAllQuyu().then(rd => {
                    this.quyuList = rd;
                })
            },
            getQuarterly(){
                var today = new Date();
                console.log("quarterly","123123");
                var quarterly  = Math.floor((today.getMonth() + 3) / 3);
                this.q.quarterly = quarterly;
                console.log("quarterly",this.q.quarterly);
            },
            //表格
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            //弹框表格
            handleSelectionChangeDialog(val){
                this.multipleSelectionDialog = val;
            },
            //根据季度获取动态表头
            getMonthList() {
                ss.grabOrderCust.getMonthList(this.q.quarterly).then(rd => {
                    console.log("monthlist",rd);
                    this.monthList = rd.obj;
                    for(var i=0;i<this.monthList.length;i++){
                        this.monthList[i].key = this.monthList[i].key+"抢单"
                    }
                });
            },
            formatDate(row, column) {
                // 获取单元格数据
                let data = row[column.property]
                if(data == null || data == '') {
                    return null
                }
                let dt = new Date(data)
                return this.$util.riQi3(dt);
            },
            uploadExcelFilecallback(rd) {
                this.query();
                this.$msg.msgs(rd.msg);
            },
            //导入Excel
            uploaddownexcelflagbtn() {
                this.uploaddownexcelflag = true;
            },
            deleteBatch(){
              this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                var list = [];
                this.multipleSelection.forEach(element => {
                  list.push(element);
                });
                console.log("delete",list);
                ss.grabOrderCust.deleteBatch(list).then(rd => {
                  this.query();
                })
              }).catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消删除'
                });
              });
            },
            //关闭弹框的事件
            closeDialog(){
                this.newDialog = false
                this.updateDialog = false
            },
            exit(){
                this.newDialog= false;
                this.add ={}
                //this.editDialog = false
            },
        },
        created() {
            this.query();
            this.getQuyu();
            this.getQuarterly();
            for(var i =2021;i<new Date() .getFullYear()+2;i++){
                this.qyearList.push(i);
            }
            this.getMonthList();
        },
        mounted() {

        },
        directives: {
            headred: {
                inserted: function (el, binding, vnode) {
                    if(binding.value){
                        el.parentNode.parentNode.style = "background: orange;color: #fff"
                    }else{
                        el.parentNode.parentNode.style = ""
                    }
                },
                update: function (el, binding, vnode) {
                    if(binding.value){
                        el.parentNode.parentNode.style = "background: orange;color: #fff"
                    }else{
                        el.parentNode.parentNode.style = ""
                    }
                }
            }
        }
    }
</script>


<style scoped>
    /* 兼容 */
    /deep/ .h-formbLine .el-form-item__label{
        width:105px;
    }
    /deep/  .h-formbLine .el-form-item__content{
        width:150px;
    }
    .addPro{
        width: 100%;
        /* display:flex; */
    }
    .addPro .el-form-item {
        width: 45% !important;
    }
    .addPro .el-form-item /deep/ .el-form-item__content{
        width:115px ;
    }
 </style>
